import axios from "axios";
import consts from "../consts";
import { initialize } from "redux-form";
import { setErroAPI, setSuccess } from "../common/toast/toast";

export function setModoTela(modo, registro = {}) {
    return {
        type: "EMPRESA_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "EMPRESA_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function initForm(registro = {}) {
    return [initialize("empresaForm", registro)];
}

export function salvar(registro) {
    const registroFormatado = { ...registro };
    registroFormatado.cnpj = String(registroFormatado.cnpj).replace(/\D/g, ""); // Remove tudo que não é número
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado || !window.confirm("Deseja realmente salvar as alterações?")) return {};
        try {
            dispatch(setAguardando(true));
            if (!registro.id) {
                await axios.post(`${consts.API_URL}/empresa`, { ...registroFormatado, id_usuario_inclusao: usuarioLogado.id });
            } else {
                await axios.put(`${consts.API_URL}/empresa`, { ...registroFormatado, id_usuario_alteracao: usuarioLogado.id });
            }
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
            dispatch(
                initForm({
                    ...registro,
                })
            );
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async (dispatch, getState) => {
        try {
            if (window.confirm("Deseja realmente excluir?")) {
                dispatch(setAguardando(true));
                await axios.delete(`${consts.API_URL}/empresa?id=${registro.id}`);
            }
            setSuccess("Operação Realizada com sucesso.");
            dispatch(getLista());
            dispatch(setModoTela("lista"));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;
            const resp = await axios.get(`${consts.API_URL}/empresa?id_empresa=${idEmpresa}`);
            dispatch({
                type: "EMPRESA_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaSelect() {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(`${consts.API_URL}/empresa/listar-select`);
            dispatch({
                type: "EMPRESA_SELECT_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
